<form [formGroup]="informatieEntiteitFg">
  <div>
    <ng-container formGroupName="legalEntityName">
      <snelstart-ui-text-form-control formControlName="value"
                                      class="me-1 custom-input-285"
                                      label="Naam onderneming"
                                      (change)="saveForm()"
      >
      </snelstart-ui-text-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="legalEntityLegalForm">
      <snelstart-ui-select-form-control formControlName="value"
                                        class="me-1 custom-input-285"
                                        label="Rechtsvorm"
                                        [options]="isRechtspersoon ? optionsLegalFormLegalEntity : optionsLegalFormNaturalPersons"
                                        (change)="saveForm()"
      >
      </snelstart-ui-select-form-control>
    </ng-container>
  </div>
  @if (!isRechtspersoon) {
    <ng-container formGroupName="legalEntityLegalFormNPOtherDescription">
      <snelstart-ui-textarea-form-control formControlName="value"
                                          class="me-1 custom-input-285"
                                          label="Toelichting op de rechtsvorm"
                                          [rows]="3"
                                          (change)="saveForm()"
      >
      </snelstart-ui-textarea-form-control>
    </ng-container>
  }
  <div>
    <ng-container formGroupName="legalEntityRegisteredOffice">
      <snelstart-ui-text-form-control formControlName="value"
                                      class="me-1 custom-input-285"
                                      label="Zetel van de onderneming"
                                      (change)="saveForm()"
      >
      </snelstart-ui-text-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="chamberOfCommerceRegistrationNumber">
      <snelstart-ui-kvk-form-control formControlName="value"
                                     class="me-1 custom-input-285"
                                     [required]="true"
                                     label="KVK-nummer"
                                     (change)="saveForm()"
      >
      </snelstart-ui-kvk-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="businessNames">
      <snelstart-ui-textarea-form-control formControlName="value"
                                          id="businessNames"
                                          label="Handelsnamen"
                                          class="me-1 custom-input-285"
                                          [rows]="2"
                                          (change)="saveForm()"
      >
      </snelstart-ui-textarea-form-control>
    </ng-container>
  </div>
  @if (isRechtspersoon) {
    <ng-container formGroupName="legalSizeCriteriaClassification">
      <snelstart-ui-select-form-control formControlName="value"
                                        class="me-1 custom-input-285"
                                        label="Classificatie van de rechtspersoon"
                                        [options]="optionsLegalSize"
                                        (change)="onLegalSizeValueChange()"
      >
      </snelstart-ui-select-form-control>
    </ng-container>
  }
  <div>
    <ng-container formGroupName="sbiBusinessCode">
      <snelstart-ui-text-form-control formControlName="value"
                                      class="me-1 custom-input-285"
                                      label="SBI-code"
                                      (change)="saveForm()"
      >
      </snelstart-ui-text-form-control>
    </ng-container>
  </div>
  <div>
    <ng-container formGroupName="dateEstablishmentLegalEntity">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-285"
                                      label="Oprichtingsdatum"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  </div>
  @if (isRechtspersoon) {
    <ng-container formGroupName="dateChangeRegulationsLegalEntity">
      <snelstart-ui-date-form-control formControlName="value"
                                      class="me-1 custom-input-285"
                                      label="Datum laatste statutenwijziging"
                                      (change)="saveForm()"
      >
      </snelstart-ui-date-form-control>
    </ng-container>
  }
  @if (!isRechtspersoon) {
    <ng-container formGroupName="numberOfBusinessPartnersInFTEsDecimals">
      <snelstart-ui-number-form-control formControlName="value"
                                        class="custom-input-285"
                                        label="Aantal zakelijke partners in FTE's"
                                        align="right"
                                        [showAllDecimals]="true"
                                        (change)="saveForm()"
      >
      </snelstart-ui-number-form-control>
    </ng-container>
  }
  <ng-container formGroupName="adres">
    <div>
      <ng-container formGroupName="streetNameNL">
        <snelstart-ui-text-form-control formControlName="value"
                                        id="streetNameNL"
                                        label="Straatnaam"
                                        class="me-1 custom-input-285"
                                        (change)="saveForm()"
        >
        </snelstart-ui-text-form-control>
      </ng-container>
    </div>
    <div class="row">
      <ng-container formGroupName="houseNumberNL">
        <snelstart-ui-number-form-control formControlName="value"
                                          id="houseNumberNL"
                                          label="Huisnr."
                                          class="me-1 custom-input-75"
                                          [showAllDecimals]="false"
                                          (change)="saveForm()"
        >
        </snelstart-ui-number-form-control>
      </ng-container>
      <ng-container formGroupName="houseNumberAddition">
        <snelstart-ui-text-form-control formControlName="value"
                                        id="houseNumberAddition"
                                        label="Toev."
                                        class="me-1 custom-input-75"
                                        (change)="saveForm()"
        >
        </snelstart-ui-text-form-control>
      </ng-container>
      <ng-container formGroupName="postalCodeNL">
        <snelstart-ui-text-form-control formControlName="value"
                                        id="postalCodeNL"
                                        label="Postcode"
                                        class="me-1 custom-input-100"
                                        (change)="saveForm()"
        >
        </snelstart-ui-text-form-control>
      </ng-container>
    </div>
    <div>
      <ng-container formGroupName="placeOfResidenceNL">
        <snelstart-ui-text-form-control formControlName="value"
                                        id="placeOfResidenceNL"
                                        label="Plaats"
                                        class="me-1 custom-input-285"
                                        (change)="saveForm()"
        >
        </snelstart-ui-text-form-control>
      </ng-container>
    </div>
  </ng-container>
</form>
<snelstart-ui-dialog-definition id="changeClassificationDialog"
                                title="Waarde wijzigen - Classificatie van de rechtspersoon"
                                size="lg"
                                [(visible)]="changeLegalSizeDialogVisible">
  <snelstart-ui-dialog-body>
    <div class="ps-1">
      <p>
        Weet je zeker dat je de waarde wilt wijzigen van
        <strong>{{ lastValueLegalSize === 'KLEIN' ? 'Klein' : 'Micro' }}</strong> naar
        <strong>{{ pendingValueLegalSize === 'KLEIN' ? 'Klein' : 'Micro' }}</strong>?
      </p>
    </div>

    <div class="ps-1">
      <p>
        <strong>Let op:</strong> het wijzigen van deze waarde heeft grote invloed op de hetgeen gedeponeerd wordt bij de
        Kamer van Koophandel.
      </p>

      <p>
        De van toepassing zijnde classificatie wanneer op twee opeenvolgende balansdata aan twee of drie van de onderstaande groottecriteria wordt voldaan.
      </p>

      <ul>
        <li>
          <strong>Micro</strong>
          <ul>
            <li>Activa: ≤ 450.000</li>
            <li>Netto-omzet: ≤ 900.000</li>
            <li>Aantal werknemers: ≤ 10</li>
          </ul>
        </li>
        <li>
          <strong>Klein</strong>
          <ul>
            <li>Activa: &gt; 450.000 en ≤ 7.500.000</li>
            <li>Netto-omzet: &gt; 900.000 en ≤ 15.000.000</li>
            <li>Aantal werknemers: &gt; 10 en ≤ 50</li>
          </ul>
        </li>
<!--        <li>-->
<!--          <strong>Middelgroot</strong>-->
<!--          <ul>-->
<!--            <li>Activa: &gt; 7.500.000 en ≤ 25.000.000</li>-->
<!--            <li>Netto-omzet: &gt; 15.000.000 en ≤ 50.000.000</li>-->
<!--            <li>Aantal werknemers: &gt; 50 en ≤ 250</li>-->
<!--          </ul>-->
<!--        </li>-->
      </ul>
    </div>
  </snelstart-ui-dialog-body>

  <snelstart-ui-dialog-buttons class="d-flex mt-2">
    <snelstart-ui-button type="secondary" icon="xmark" btn-x
                         (click)="cancelChange()">Nee, annuleren
    </snelstart-ui-button>

    <snelstart-ui-button class="ps-3" type="primary" icon="check"
                         (click)="confirmChange()">Ja, bevestigen
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
